import type React from 'react';
import { FormField, FormHelp, Label } from '@zillow/constellation-10';

import type { Section } from '../../../../models';
import { SECURITY_DEPOSIT } from '../../../../constants';
import CurrencyInput from '../../../Widgets/CurrencyInput';

type Props = {
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onBlur: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  dataTest?: string;
  section: Section;
  errorMessage?: string;
};

export default function SecurityDepositCurrencyInput({ section, dataTest, errorMessage, ...rest }: Props) {
  const field = section.getField(SECURITY_DEPOSIT.FIELD_NAME.AMOUNT);
  const value = section.getFieldValue(SECURITY_DEPOSIT.FIELD_NAME.AMOUNT);

  return (
    <FormField
      required
      label={<Label>Security deposit</Label>}
      error={field.hasError}
      control={<CurrencyInput value={value} data-test={dataTest} {...rest} />}
      description={<FormHelp>{field.hasError ? field.getErrorMessage() : errorMessage}</FormHelp>}
    />
  );
}
